import React, { useState } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import SaveIcon from "@mui/icons-material/Save";

export default function FormDialog({ title, children, open, onClose, submitting = false, onConfirm, contentStyle, ...props }) {
  // const [open, setOpen] = useState(false);
  // const [val, setVal] = useState('')

  // const handleClickOpen = () => {
  //   setOpen(true);
  // };

  const handleConfirm = () => {
    // setOpen(false);
    onConfirm();
  };

  return (
    <Dialog
      open={open}
      // onClose={onClose}
      maxWidth="unset"
      {...props}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent sx={contentStyle}>
        {/* <DialogContentText>请输入代理名称</DialogContentText> */}
        {children}
        {/* <TextField autoFocus margin="dense" id="name" label="代理名称" fullWidth variant="standard" value={val} 
          autoComplete="off"
          onChange={e => setVal(e.currentTarget.value)} /> */}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined">
          取消
        </Button>

        {/* <Button
          onClick={handleConfirm}
          disabled={submitting}
          style={{
            cursor: submitting ? "not-allowed" : "pointer",
          }}
        >
          确定
        </Button> */}

        <LoadingButton size="small" color="primary" onClick={handleConfirm} loading={submitting} loadingPosition="start" variant="contained">
          <span>确定</span>
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}
